module.exports = __webpack_public_path__ + "img/piani_passati.6c1314db.svg";